/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "~/backend/axiosClient"
import type {
  GenerateAlertsQueryResponse,
  GenerateAlertsQueryParams,
} from "../types/GenerateAlerts.ts"
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query"
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"
import { queryOptions, useQuery } from "@tanstack/react-query"

export const generateAlertsQueryKey = (params: GenerateAlertsQueryParams) =>
  [{ url: "/v1/filter/generate-alerts" }, ...(params ? [params] : [])] as const

export type GenerateAlertsQueryKey = ReturnType<typeof generateAlertsQueryKey>

/**
 * @summary Generate alerts
 * {@link /v1/filter/generate-alerts}
 */
export async function generateAlerts(
  params: GenerateAlertsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    GenerateAlertsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/v1/filter/generate-alerts`,
    params,
    ...requestConfig,
  })
  return res
}

export function generateAlertsQueryOptions(
  params: GenerateAlertsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = generateAlertsQueryKey(params)
  return queryOptions<
    ResponseConfig<GenerateAlertsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GenerateAlertsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!params,
    queryKey,
    queryFn: async ({ signal }) => {
      return generateAlerts(params, {
        ...config,
        signal: config.signal ?? signal,
      })
    },
  })
}

/**
 * @summary Generate alerts
 * {@link /v1/filter/generate-alerts}
 */
export function useGenerateAlerts<
  TData = ResponseConfig<GenerateAlertsQueryResponse>,
  TQueryData = ResponseConfig<GenerateAlertsQueryResponse>,
  TQueryKey extends QueryKey = GenerateAlertsQueryKey,
>(
  params: GenerateAlertsQueryParams,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GenerateAlertsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey = resolvedOptions?.queryKey ?? generateAlertsQueryKey(params)

  const query = useQuery(
    {
      ...generateAlertsQueryOptions(params, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
